<style>
.el-collapse-item__wrap {
    width: 100%;
}
.bidder-params-box {
    border: 2px solid #3c8dbc;
    /*margin: 20px auto;*/
}
.bidder-params {
    margin: 5px auto;
}
/*.box-body{
		padding: 0px 30px !important;
	}*/
.recentlyClosed {
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}
.opened {
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}
.enabled-bidders {
    max-height: 50px;
    display: inline-flex;
}
.enabled-bidders p {
    display: inline;
    background: #8b85e5;
    margin: 0 5px;
    padding: 2px;
    border-radius: 3px;
    color: #18171a;
}
.collapse--item {
    margin-bottom: 10px;
    padding-left: 10px;
    padding-right: 10px;
}

.collapse--item:first-child {
    margin-top: 10px;
}
.el-collapse-item__wrap {
    width: 100%;
}
div[role='tabpanel'] {
    width: 100%;
}
.el-collapse-item__wrap {
    width: 100%;
}
span.param-type {
    background: aquamarine;
    padding: 2px;
    border-radius: 2px;
}
</style>
<template>
    <div class="content-wrapper">
        <section class="content">
            <div class="box">
                <div class="box-header with-border">
                    <h3 class="box-title">Edit/create Param sets</h3>
                    <el-button
                        :disabled="loading"
                        type="primary"
                        class="pull-right"
                        @click="showCreateParamSetDialog = true"
                        >Create Param set</el-button
                    >
                    <el-input
                        style="display: inline-block; width: 80%; margin: 0 0 10px 10px"
                        data-vv-delay="1000"
                        name="searchString"
                        type="text"
                        placeholder="search HB Unit by HB Unit tag (type and enter)"
                        v-model="searchString"
                        @keyup.enter.native="filterHbparamset()"
                    >
					</el-input>
                    <el-tooltip content="clearSearch" placement="top">
                        <el-button
                            type="danger"
                            icon="el-icon-close"
                            @click="clearSearch()"
                            style="display: inline-block"
                        >
                            <!-- <i class="el-icon-close"></i> -->
                        </el-button>
                    </el-tooltip>
                </div>

                <el-dialog
                    class="element-promt"
                    title="Clone param set"
                    :visible.sync="showAliasNameDialog"
                    width="40%"
                    :before-close="handleClose"
                >
                    <h5>Alias name</h5>
                    <el-input type="text" :rows="10" v-model="cloneParamSet.alias"></el-input>

                    <h5>IS AMP?</h5>
                    <el-switch v-model="cloneParamSet.is_amp" :disabled="cloningSet && cloningSet.is_amp"> </el-switch>

                    <span slot="footer" class="dialog-footer">
                        <el-button type="primary" @click="cloneParamSetSubmit">Create clone</el-button>
                    </span>
                </el-dialog>

                <el-dialog
                    class="element-promt"
                    title="Input alias name"
                    :visible.sync="showCreateParamSetDialog"
                    width="40%"
                    :before-close="handleClose"
                >
                    <h5>Alias name</h5>
                    <el-input type="text" :rows="10" v-model="newParamSet.alias"></el-input>

                    <h5>IS AMP?</h5>
                    <el-switch v-model="newParamSet.is_amp"> </el-switch>

                    <h5>Dimension</h5>
                    <el-select
                        class="param-set-input select-input"
                        v-model="newParamSet.dimension"
                        filterable
                        placeholder="Select dimension"
                    >
                        <el-option
                            v-for="dimension in dimensions"
                            :key="dimension.id"
                            :label="`${dimension.width}X${dimension.height}`"
                            :value="dimension.id"
                        >
                        </el-option>
                    </el-select>

                    <span slot="footer" class="dialog-footer">
                        <el-button :disabled="!createParamSetButtonValid" type="primary" @click="createParamSet"
                            >Create Param set</el-button
                        >
                    </span>
                </el-dialog>

                <div class="box-body" v-loading="loading">
                    <div class="clearfix">
                        <div v-for="param_set in param_sets">
                            <el-collapse v-model="activeNames" @change="handleChange" accordion>
                                <el-collapse-item
                                    v-bind:class="{
                                        recentlyClosed: recentlyClosed == param_set.alias,
                                        opened: activeNames == param_set.alias,
                                    }"
                                    :title="param_set.alias"
                                    :name="param_set.alias"
                                    class="collapse--item"
                                    style="width: 100%"
                                >
                                    <template slot="title">
                                        <!-- <div style="width: 100%;">
											<div style="width: 50%;float: left;position: relative;">
												{{ param_set.alias }}
											</div>
											<div style="width: 45%;float: left;position: relative;">
												<el-button class="el-button el-button--info pull-right" @click="cloneParamSet(param_set)">
													Clone Param Set
												</el-button >
											</div>
										</div> -->

                                        <el-row>
                                            <el-col :span="7">
                                                <div class="grid-content">
                                                    <div>
                                                        <h5>
                                                            {{ param_set.alias }} -
                                                            <span class="param-type"
                                                                >({{ param_set.is_amp ? 'AMP' : 'Display' }})</span
                                                            ><span
                                                                v-if="!param_set.id"
                                                                style="color: red; font-style: italic"
                                                                >* NOT SAVED</span
                                                            >
                                                        </h5>
                                                    </div>
                                                </div>
                                            </el-col>

                                            <el-col :span="12">
                                                <div class="grid-content" style="overflow: scroll">
                                                    <div class="enabled-bidders">
                                                        <p v-for="bidder in getEnabledBidders(param_set.params)">
                                                            {{ bidder }}
                                                        </p>
                                                        <p
                                                            style="color: #a13333"
                                                            v-show="getEnabledBidders(param_set.params).length == 0"
                                                        >
                                                            No bidders enabled
                                                        </p>
                                                    </div>
                                                </div>
                                            </el-col>

                                            <el-col :span="2" style="padding-left: 10px">
                                                <div class="grid-content">
                                                    <div>
                                                        <el-button
                                                            class="el-button el-button--info"
                                                            @click.stop="cloneDialog(param_set)"
                                                        >
                                                            Clone Param Set
                                                        </el-button>
                                                    </div>
                                                </div>
                                            </el-col>
                                        </el-row>
                                    </template>
                                    <div style="width: 100%" v-if="activeNames == param_set.alias">
                                        <!-- <h1>
											{{ getDimensionInStr(param_set.dimension.id) }}
										</h1> -->
                                        <!-- <h3>{{ getParams(param_set) }}</h3> -->

                                        <div
                                            v-for="bidder in param_set.is_amp ? ampBidders : bidders"
                                            class="col-md-12"
                                            style="width: 98%; left: 1%"
                                            v-bind:class="{
                                                'bidder-params-box': param_set.params[bidder.code]['enabled'],
                                                'bidder-params': true,
                                            }"
                                            v-if="(param_set.is_amp && bidder.amp_enabled) || !param_set.is_amp"
                                        >
                                            <div>
                                                <el-checkbox
                                                    name="bidder[]"
                                                    :id="`${param_set.id}-${bidder.code}`"
                                                    v-model="param_set.params[bidder.code]['enabled']"
                                                >
                                                    <!-- v-model="param_set.params[bidder.code]['enabled']" -->
                                                    <!-- <input type="checkbox" v-model="param_set.params[bidder.code]['enabled']">{{ bidder.name }} <br> -->
                                                    <!-- <el-switch
			  											v-model="param_set.params[bidder.code]['enabled']">
			  										</el-switch> -->
                                                    <!-- <h4>{{ param_set.params[bidder.code]['enabled'] }}</h4> -->
                                                    <!-- <label :for="bidder.bidder.code"> -->
                                                    {{ bidder.name }}
                                                    <!-- </label> -->
                                                </el-checkbox>
                                            </div>

                                            <div
                                                v-for="field in getBidderFields(bidder, param_set.is_amp)"
                                                class="col-md-4"
                                                v-if="param_set.params[bidder.code]['enabled']"
                                            >
                                                <div v-if="field.type == 'text'" class="form-group">
                                                    <div>
                                                        <p :for="field.label" class="bold pull-left">
                                                            {{ field.label }}
                                                        </p>
                                                        <input
                                                            v-trim
                                                            v-model="
                                                                param_set.params[bidder.code]['bidder_params'][
                                                                    field.name
                                                                ]
                                                            "
                                                            type="text"
                                                            :id="field.label"
                                                            class="form-control"
                                                        />
                                                    </div>
                                                </div>

                                                <div
                                                    v-if="field.type == 'number' || field.type == 'float'"
                                                    class="form-group"
                                                >
                                                    <div>
                                                        <p :for="field.label" class="bold pull-left">
                                                            {{ field.label }}
                                                        </p>
                                                        <input
                                                            v-model.number="
                                                                param_set.params[bidder.code]['bidder_params'][
                                                                    field.name
                                                                ]
                                                            "
                                                            type="number"
                                                            id="field.label"
                                                            class="form-control"
                                                            step="0.01"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <el-button
                                        style="float: right; margin: 10px"
                                        type="primary"
                                        @click="applyTagParamSetBidder(param_set)"
                                        >Apply</el-button
                                    >
                                </el-collapse-item>
                            </el-collapse>
                        </div>
                        <el-pagination
                            style="text-align: center; margin-top: 30px"
                            @current-change="handleCurrentChange"
                            :page-size="offset"
                            :pager-count="20"
                            layout="prev, pager, next"
                            :total="total_pages"
                            :current-page.sync="currentPage"
                        >
                        </el-pagination>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import axios from 'axios';
export default {
    data() {
        return {
            searchString: '',
            currentPage: 1,
            total_pages: 1,
            offset: 20,
            domId: undefined,
            param_sets: [],
            param_set_bidders: [],
            dimensions: [],
            bidders: [],
            allBidders: [],
            ampBidders: [],
            cloneParamSet: {
                alias: '',
                is_amp: false,
            },
            cloningSet: undefined,
            isSearch: false,
            recentlyClosed: '',
            activeNames: undefined,
            showAliasNameDialog: false,
            showCreateParamSetDialog: false,
            loading: true,
            newParamSet: {
                alias: '',
                is_amp: false,
                dimension: undefined,
            },

        };
    },


    props: {
	  is_amp: Boolean
	},


	watch: {
		'$route' (to, from) {
			console.warn(`route changed from ${from} to ${to}`);
			this.initialize(this.currentPage);
		}
	},

    created: function () {
        this.initialize();
    },
    directives: {
        trim: {
            // directive definition
            inserted: function (el) {
                // console.log('Inserted');
            },
            bind: function (el, binding, vnode) {
                var handler = function (e) {
                    let old = e.target.value;
                    e.target.value = e.target.value.trim();
                    if (old != e.target.value) vnode.elm.dispatchEvent(new CustomEvent('input')); // added this
                };
                el.addEventListener('input', handler);
            },
        },
    },
    methods: {
        clearSearch() {
            this.searchString = '';
            this.initialize(1);
        },
        filterHbparamset() {
            this.isSearch = true;
            this.currentPage = 1;

            this.initialize(this.currentPage);
        },
        handleCurrentChange(val) {
            console.log('val', val);
            console.log('this.search', this.searchString);

            this.currentPage = val;

            this.initialize(val);
        },
        initialize(pageNum) {
            if (this.searchString.length != 0) {
                this.isSearch = true;
                console.log('this.search in abc', this.isSearch, this.searchString.length);
            }

            this.loading = true;
            console.log('pagenum', pageNum);
            if (pageNum == undefined) {
                pageNum = 1;
            }
            this.domId = this.$route.params.domId;

            var viewApi =
                BASE_URL + `v1/hb-tag-param-set/${this.domId}/?page=${this.currentPage}&&offset=${this.offset}`;
            var searchapi =
                BASE_URL +
                `v1/search-hb-tag-param-sets/domain/${this.domId}/?page=${this.currentPage}&&offset=${this.offset}&&query=${this.searchString}`;
            axios
                .all([
                    axios.get(this.isSearch ? searchapi : viewApi),
                    axios.get(BASE_URL + 'v1/ad-dimensions/'),
                    axios.get(BASE_URL + 'v1/hb-tag-param-set-bidders/' + this.domId + '/'),
                    axios.get(BASE_URL + 'v1/get-bidders-under-domain/' + this.domId),
                    axios.get(BASE_URL + 'v1/bidders/'),
                ])
                .then(
                    axios.spread((param_sets, dimensions, param_set_bidders, bidders, allBidders) => {
                        this.isSearch = false;
                        this.total_pages = param_sets.data.total;
                        console.log(allBidders);
                        this.allBidders = allBidders.data;
                        this.ampBidders = this.allBidders.filter((bidder) => bidder.amp_enabled);
                        console.log(this.ampBidders);
                        console.log('@@#param_sets', param_sets.data.total);
                        this.dimensions = dimensions.data;
                        this.bidders = bidders.data;
                        this.enabled_bidder_ids = this.bidders.map((bidder) => {
                            return bidder.id;
                        });
                        this.param_set_bidders = param_set_bidders.data;
                        this.initializeParamSets(param_sets.data);

                        this.loading = false;
                    })
                );
        },
        initializeParamSets(param_sets) {
            console.log('in param set', param_sets);
            let param_sets_clone = param_sets.data.map((param_set) => {
                let data = this.getParams(param_set);
                param_set['params'] = data;
                return param_set;
                
            });
            this.param_sets = param_sets_clone;
        },
        getDimensionInStr(id) {
            let dimension = this.dimensions.filter((dimen) => {
                return dimen['id'] == id;
            })[0];
            return `${dimension.width}X${dimension.height}`;
        },
        handleChange(val) {
            this.recentlyClosed = this.prevActiveNames;
            this.prevActiveNames = this.activeNames;
            if (val != '') this.recentlyClosed = '';
        },
        cloneDialog(paramSet) {
            this.showAliasNameDialog = true;
            this.cloneParamSet.alias = `${paramSet.alias} - cloned`;
            this.cloningSet = paramSet;
            this.cloneParamSet.is_amp = paramSet.is_amp;
        },
        getBiddersEnabled(is_amp) {
            if (is_amp) {
                return this.allBidders.filter((bidder) => {
                    return bidder.amp_enabled;
                });
            } else {
                let bidders = this.bidders.filter((bidder) => {
                    return bidder;
                });
                return bidders;
            }
        },
        cloneParamSetSubmit() {
            let paramSet = this.cloningSet,
                bidders = [];
            let idx = this.param_sets.findIndex((set) => {
                return paramSet.id == set.id;
            });

            let newParams = JSON.parse(JSON.stringify(paramSet.params));

            let enabledBidders = this.getBiddersEnabled(this.cloneParamSet.is_amp);
            let enabledBiddersCodes = enabledBidders.map((enabledBidder) => enabledBidder.code);
            enabledBiddersCodes.forEach((code) => {
                if (!newParams[code]) {
                    newParams[code] = {
                        bidder_params: {},
                        enabled: false,
                        ownership: true,
                    };
                }
            });
            for (let key in newParams) {
                if (!enabledBiddersCodes.includes(key)) {
                    delete newParams[key];
                    continue;
                }
                if (this.cloneParamSet.is_amp) {
                    bidders = this.ampBidders;
                } else {
                    bidders = this.bidders;
                }
                let bidderObj = bidders.filter((bidder) => {
                    return bidder.code == key;
                })[0];
                let fields = this.getBidderFields(bidderObj, this.cloneParamSet.is_amp);
                fields.forEach((field) => {
                    if (field.type == 'text') {
                        newParams[key]['bidder_params'][field.label] = String(
                            newParams[key]['bidder_params'][field.label]
                        );
                    } else if (field.type == 'number') {
                        newParams[key]['bidder_params'][field.label] = parseInt(
                            newParams[key]['bidder_params'][field.label]
                        );
                    } else if (field.type == 'float') {
                        newParams[key]['bidder_params'][field.label] = parseFloat(
                            newParams[key]['bidder_params'][field.label]
                        );
                    }
                });
            }

            this.param_sets.splice(idx + 1, 0, {
                alias: this.cloneParamSet.alias,
                dimension: JSON.parse(JSON.stringify(paramSet.dimension)),
                domain: JSON.parse(JSON.stringify(paramSet.domain)),
                id: undefined,
                params: newParams,
                is_amp: this.cloneParamSet.is_amp,
            });
            this.cloneParamSet = {
                alias: '',
                is_amp: false,
            };
            this.cloningSet = undefined;
            this.handleClose();
        },
        createParamSet() {
            let requestObject = {
                alias: this.newParamSet.alias,
                dimension: this.newParamSet.dimension,
                domain: this.domId,
                is_amp: this.newParamSet.is_amp,
            };
            axios
                .post(BASE_URL + 'v1/hb-tag-param-set/' + this.domId + '/', requestObject)
                .then((response) => {
                    console.log(response);
                    let param_set = response.data;

                    let data = this.getParams(param_set);
                    param_set['params'] = data;

                    this.param_sets.push(response.data);

                    this.$notify({
                        title: 'Success',
                        message: 'Successfully applied!!',
                        type: 'success',
                    });

                    this.recentlyClosed = this.activeNames;
                    this.activeNames = '';
                    this.newParamSet = {
                        alias: '',
                        is_amp: false,
                        dimension: undefined,
                    };
                    this.handleClose();
                })
                .catch((error) => {
                    console.log('Error:', error);
                    this.handleClose();
                });
        },
        handleClose() {
            this.showAliasNameDialog = false;
            this.showCreateParamSetDialog = false;
        },
        getParams(param_set) {
            let params = this.param_set_bidders.filter((set) => {
                return set.hb_tag_param_set.id == param_set.id;
            });
            let final = params.reduce((accumulator, current) => {
                current.bidder_params = JSON.parse(current.bidder_params);
                // if (!accumulator.find((p) => (p.bidder.id === current.bidder.id && p.hb_tag_param_set.id === current.hb_tag_param_set.id)) && current.bidder_params[this.getBidderFields(current.bidder)[0]['name']]) {

                if (
                    !accumulator.find(
                        (p) =>
                            p.bidder.id === current.bidder.id && p.hb_tag_param_set.id === current.hb_tag_param_set.id
                    ) &&
                    (this.enabled_bidder_ids.includes(current.bidder.id) || param_set.is_amp)
                ) {
                    accumulator.push(current);
                }
                return accumulator;
            }, []);
            // let res = params.map((param) => {
            // 	return {'alias': param.hb_tag_param_set.alias, 'bidder': param.bidder.code};
            // });
            let res = {},
                bidders = [];
            if (param_set.is_amp) {
                bidders = this.ampBidders;
            } else {
                bidders = this.bidders;
            }
            bidders.forEach((bidder) => {
                // this.$set(res[bidder.code], 'bidder_params', {})
                // this.$set(res[bidder.code], 'enabled', false)
                // this.$set(res[bidder.code], 'ownership', true)

                res[bidder.code] = {
                    bidder_params: {},
                    enabled: false,
                    ownership: true,
                };
                let defaults = this.getDefaults(bidder.id, param_set);
                res[bidder.code]['bidder_params'] = JSON.parse(defaults);
            });

            final.forEach((fi) => {
                // console.log(fi.bidder_params);
                if (!res[fi.bidder.code]) return;
                if (Object.keys(fi.bidder_params).length === 0 && fi.bidder_params.constructor === Object) {
                    //Check if object empty
                    let defaults = this.getDefaults(fi.bidder.id, param_set);
                    res[fi.bidder.code]['bidder_params'] = JSON.parse(defaults);
                } else {
                    res[fi.bidder.code]['bidder_params'] = fi.bidder_params;
                }

                res[fi.bidder.code]['enabled'] = fi.enabled;
                res[fi.bidder.code]['ownership'] = fi.ownership;
            });
            // return final;
            return res;
        },
        getDefaults(bidderId, param_set) {
            let dimension = undefined;
            if (param_set) dimension = `${param_set.dimension.width}X${param_set.dimension.height}`;
            let bidder = this.bidders.find((bidder) => {
                return bidderId == bidder.id;
            });
            if (!bidder) return '{}';
            let params = JSON.parse(bidder.param),
                res = {},
                criteo_zones = {"300X250": 1783440,"300X600": 1783441,"300X100": 1783444,"300X50": 1783445,"320X50": 1783446,"320X100": 1783447,"728X90": 1783449,"970X250": 1783451,"970X90": 1783452,"120X600": 1783455,"160X600": 1783456};
            params.forEach((param) => {
                if (param.hasOwnProperty('default')) res[param['name']] = param['default'];
                if (dimension) {
                    console.log(dimension);
                    if (bidder.code == 'pulsepoint' && param['name'] == 'cf') res[param['name']] = dimension;
                    if (bidder.code == 'smartadserver' && param['name'] == 'formatId' && dimension == '300X250')
                        res[param['name']] = 67786;
                    if (bidder.code == 'smartadserver' && param['name'] == 'formatId' && dimension == '728X90')
                        res[param['name']] = 92351;
                    if (bidder.code == 'smartadserver' && param['name'] == 'formatId' && dimension == '160X600')
                        res[param['name']] = 92352;
                    if (bidder.code == 'smartadserver' && param['name'] == 'formatId' && dimension == '300X600')
                        res[param['name']] = 92353;
                    if (bidder.code == 'smartadserver' && param['name'] == 'formatId' && dimension == '320X50')
                        res[param['name']] = 92354;
                    if (bidder.code == 'smartadserver' && param['name'] == 'formatId' && dimension == '970X90')
                        res[param['name']] = 92355;
                    if (bidder.code == 'smartadserver' && param['name'] == 'formatId' && dimension == '970X250')
                        res[param['name']] = 92356;
                    if (bidder.code == 'adyoulike' && param['name'] == 'placement' && dimension == '300X250')
                        res[param['name']] = '69d53a8997ba2aade0afae3c0e13b7e2';
                    if (bidder.code == 'adyoulike' && param['name'] == 'placement' && dimension == '728X90')
                        res[param['name']] = 'd1628350e52378b475ee425f09726e03';
                    if (bidder.code == 'adyoulike' && param['name'] == 'placement' && dimension == '160X600')
                        res[param['name']] = '501328d77374a58a6432d41c8ab7fb1c';
                    if (bidder.code == 'adyoulike' && param['name'] == 'placement' && dimension == '300X600')
                        res[param['name']] = '733f2188df1a63c95e9959044c63cf87';
                    if (bidder.code == 'adyoulike' && param['name'] == 'placement' && dimension == '320X50')
                        res[param['name']] = '7fcf92fd933e8cdf2db910dee96e7890';
                    if (bidder.code == 'adyoulike' && param['name'] == 'placement' && dimension == '970X90')
                        res[param['name']] = '794587a396288579e9ecf21e1ef94bff';
                    if (bidder.code == 'adyoulike' && param['name'] == 'placement' && dimension == '970X250')
                        res[param['name']] = 'fa2370e9c8f44911be90b58852e3effc';
                    if (bidder.code == 'criteo' && param['name'] == 'zoneId'){
                        if(dimension in criteo_zones)
                            res[param['name']] = criteo_zones[dimension]
                    }
                }
            });
            return JSON.stringify(res);
        },
        getBidderFields(bidder, is_amp) {
            if (is_amp) {
                return JSON.parse(bidder.amp_param);
            } else {
                return JSON.parse(bidder.param);
            }
        },
        applyTagParamSetBidder(param_set) {
            // console.log('applyTagParamSetBidder');
            console.log(param_set);
            let requestObject = {
                param_set: JSON.stringify(param_set),
            };
            axios
                .post(BASE_URL + 'v1/hb-tag-param-set-bidders/' + this.domId + '/', requestObject)
                .then((response) => {
                    console.log(response);
                    param_set.id = response.data.param_set_id;

                    this.$notify({
                        title: 'Success',
                        message: 'Successfully applied!!',
                        type: 'success',
                    });

                    this.recentlyClosed = this.activeNames;
                    this.activeNames = '';
                })
                .catch(function (error) {
                    console.log('Error:', error);
                });
        },
        checkMod(param) {
            param.enabled = !param.enabled;
            // this.$forceUpdate();
        },
        getEnabledBidders(params) {
            // let found_set = this.param_sets.find((set) => {
            // 	return set.id == param_set_id;
            // });
            // console.log(found_set);
            let enabled_bidders = [];
            for (var bidder in params) {
                if (params[bidder]['enabled']) enabled_bidders.push(bidder);
            }
            return enabled_bidders;
        },
    },
    computed: {
        createParamSetButtonValid() {
            return this.newParamSet.alias.length > 0 && this.newParamSet.dimension;
        },
    },
};
</script>



<!-- Clone button enabled when atleast one bidder is active -->


// WEBPACK FOOTER //
// HbTagParamSet.vue?f1ed68fe